export enum ButterPageType {
  DEFAULT = 'tablevolleyball_pages',
  EDUCATION = 'tablevolleyball_education',
  FAQ = 'faq',
}
